function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.82591 4.72604C7.13097 4.72604 8.18893 3.66808 8.18893 2.36302C8.18893 1.05796 7.13097 0 5.82591 0C4.52085 0 3.46289 1.05796 3.46289 2.36302C3.46289 3.66808 4.52085 4.72604 5.82591 4.72604Z",
  fill: "#21314D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.18844 8.89981V7.13867H3.26902H0V9.52076V11.9029H3.26902H3.56943V16.4498V24.0003H5.87947H8.18897V16.4498V8.89981H8.18844Z",
  fill: "#21314D"
});

const SvgI = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 24,
  viewBox: "0 0 9 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgI, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/I.c452e9bf.svg";
export { ForwardRef as ReactComponent };